import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

var campsReviewSwiper = new Swiper('.camps-review-slider-content', {
  modules: [Navigation, Pagination],
  slidesPerView: 3,
  spaceBetween: 24,
  centeredSlides: true,
  loop: true,
  grabCursor: true,
  pagination: {
    el: '.camps-review-swiper-pagination',
    clickable: 'true',
  },
  navigation: {
    nextEl: '.camps-reviews-swiper-button-prev',
    prevEl: '.camps-reviews-swiper-button-next',
  },

  breakpoints: {
    0: {
      slidesPerView: 'auto',
      spaceBetween: 24,
    },
    720: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    950: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});
